<header class="top-bar">
  <div class="row no-gutters">
    <div class="align-items-center col-6">
      <nav class="top-nav">
        <div class="brand col-auto">
          <img class="pointer" src="/assets/images/logo/cal-logo-crmx.png" routerLink="/" width="120px" />
        </div>
      </nav>
    </div>
    <div class="navbar-links ml-auto mt-auto mb-auto align-items-center">
      <ul class="nav navbar navbar-right">
        <li [hidden]="login">
          <span *ngIf="!ipoLogin" [routerLink]="['/login']" class="link-text cursor-pointer">Login</span>
          <span *ngIf="ipoLogin" (click)="refreshIPO()" class="link-text cursor-pointer">Login</span>
        </li>
        <li [hidden]="!login">
          <span routerLink="/dashboard" [queryParams]="{ uid: currentUser?.id }" class="link-text cursor-pointer">Dashboard</span>
        </li>
        <li class="separator">&nbsp;|&nbsp;</li>
        <li [hidden]="login">
          <span [routerLink]="['/registration']" class="link-text cursor-pointer">Register</span>
        </li>
        <li [hidden]="!login"><span (click)="logout()" class="link-text cursor-pointer">Logout</span></li>
      </ul>
    </div>
  </div>
</header>
<div class="main-content portal-page col-12">
  <router-outlet></router-outlet>
</div>
